import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {VorhersageComponent} from './component/thema/vorhersage/vorhersage.component';
import {MesswertComponent} from './component/thema/messwert/messwert.component';
import {UnwetterComponent} from './component/thema/unwetter/unwetter.component';
import {GesundheitComponent} from './component/thema/vorhersage/meteorologe/gesundheit/gesundheit.component';
import {PollenflugComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug.component';
import {UvIndexComponent} from './component/thema/vorhersage/meteorologe/gesundheit/uv-index/uv-index.component';
import {OzonwerteComponent} from './component/thema/vorhersage/meteorologe/gesundheit/ozonwerte/ozonwerte.component';
import {LoginComponent} from './component/login/login.component';
import {AuthGuardService as AuthGuard} from './service/auth/auth-guard.service';
import {RadarBilderAktuellComponent} from './component/thema/regeneradar/radar-bilder/radar-bilder-aktuell/radar-bilder-aktuell.component';
import {MeteorologeComponent} from './component/thema/vorhersage/meteorologe/meteorologe.component';
import {ComputerMosComponent} from './component/thema/vorhersage/computer-mos/computer-mos.component';
import {
  DreiStundenVorhersageComponent
} from './component/thema/vorhersage/computer-mos/details/drei-stunden-vorhersage/drei-stunden-vorhersage.component';
import {
  VierundzwanzigStundenVorhersageComponent
} from './component/thema/vorhersage/computer-mos/details/vierundzwanzig-stunden-vorhersage/vierundzwanzig-stunden-vorhersage.component';
import {WetterberichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wetterbericht.component';
import {BiowetterComponent} from './component/thema/vorhersage/meteorologe/gesundheit/biowetter/biowetter.component';
import {AutomatisiertComponent} from './component/thema/vorhersage/automatisiert/automatisiert.component';
import {APP_BASE_HREF, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {SonstigesComponent} from './component/thema/sonstiges/sonstiges.component';
import {FreizeitWetterComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/freizeit-wetter.component';
import {
  WintersportWetterComponent
} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wintersport-wetter/rbb-wintersport-wetter/wintersport-wetter.component';
import {
  WassersportWetterComponent
} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wassersport-wetter/wassersport-wetter.component';
import {
  RadarBilderVorhersagenComponent
} from './component/thema/regeneradar/radar-bilder/radar-bilder-vorhersagen/radar-bilder-vorhersagen.component';

const routes: Routes = [
  {path: '', redirectTo: 'vorhersagen', pathMatch: 'full'},
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'vorhersagen',
    component: VorhersageComponent,
    data: {breadcrumb: 'vorhersagen'},
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'computer-mos/uebersicht',
        component: ComputerMosComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
      },
    ]
  },

  {
    path: 'vorhersagen/meteorologe',
    component: MeteorologeComponent,
  },
  // children: [
  {
    path: 'vorhersagen/meteorologe/wetterberichte',
    component: WetterberichtComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',

  },
  {
    path: 'vorhersagen/meteorologe/gesundheit',
    component: GesundheitComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'vorhersagen/meteorologe/freizeit',
    component: FreizeitWetterComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'vorhersagen/meteorologe/freizeit/wintersportwetter',
    component: WintersportWetterComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'vorhersagen/meteorologe/freizeit/wassersportwetter',
    component: WassersportWetterComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },


  // children: [
  {
    path: 'vorhersagen/meteorologe/gesundheit/biowetter',
    component: BiowetterComponent
  },
  {
    path: 'vorhersagen/meteorologe/gesundheit/pollenflug',
    component: PollenflugComponent
  },
  {
    path: 'vorhersagen/meteorologe/gesundheit/uv-index',
    component: UvIndexComponent
  },
  {
    path: 'vorhersagen/meteorologe/gesundheit/ozonwerte',
    component: OzonwerteComponent
  },

  // }
  // ]
  // },

  // children: [
  {
    path: 'vorhersagen/computer-mos/automatisiert',
    component: AutomatisiertComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },

  // ]
  // },
  //Hier ging das mit den "children" nicht, da sonst die Route falsch war
  {
    path: 'vorhersagen/computer-mos/uebersicht/3-stunden',
    component: DreiStundenVorhersageComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',

  },
  {
    path: 'vorhersagen/computer-mos/uebersicht/24-stunden',
    component: VierundzwanzigStundenVorhersageComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },

  // ]


  {
    path: 'unwetterwarnungen', component: UnwetterComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always',

  },

  {
    path: 'messwerte', component: MesswertComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  {
    path: 'radarbilder/aktuell', component: RadarBilderAktuellComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always',

  },
  {
    path: 'radarbilder/vorhersagen', component: RadarBilderVorhersagenComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always',

  },

  {
    path: 'sonstiges', component: SonstigesComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always',

  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload',})],
  exports: [RouterModule],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    {provide: APP_BASE_HREF, useValue: '/'},
  ]
})
export class AppRoutingModule {
}
